import { CandidateFormPage } from "~/pages/CandidateFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/candidates/edit/$id")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const [candidate] = await Promise.all([
      queryClient.fetchQuery(trpc.candidates.getById.queryOptions({ id: params.id })),
      queryClient.fetchQuery(trpc.candidatesSettings.get.queryOptions()),
    ]);
    return { candidate };
  },
});

function RouteComponent() {
  const { candidate } = Route.useLoaderData();
  useBreadCrumbs([
    { title: "Candidates", link: `/${location.pathname.split("/")[1]}/data/candidates` },
    { title: "Edit", link: `/${location.pathname.split("/")[1]}/data/candidates/edit/${candidate.id}` },
  ]);
  return <CandidateFormPage candidate={candidate} />;
}
